<!--
 * @description: 科普文创
 * @Author: Jay
 * @Date: 2021-09-17 10:48:27
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-13 11:09:56
-->
<template>
  <div class="bg-color">
    <!-- 顶部 背景 标题 -->
    <bg-img-top
      :bgImg="$api + reData.image"
      EnTitle="Popular Science Literature Creation"
      title="科普文创"
      v-if="reData != ''"
    ></bg-img-top>
    <!-- 边距 -->
    <div class="margin-top margin-bottom"></div>
    <!-- 内容 -->
    <div class="fix-width" v-if="reData != ''">
      <!-- 商品列表 -->
      <goods-code
        id="0"
        title="科普文创"
        name="Popular Science Literature Creation"
        :tabList="reData.data"
        :tabID="seleId"
      ></goods-code>
    </div>
    <!-- 边距 -->
    <div class="padding-top padding-bottom"></div>
  </div>
</template>

<script>
// 顶部 背景 标题
import bgImgTop from "@/components/tab/bg-img-top.vue";
// 商品列表
import goodsCode from "../../components/carousel/goods-code.vue";
import { cultural } from "../../api/api";

export default {
  name: "Cultural",
  components: {
    bgImgTop,
    goodsCode,
  },
  data() {
    return {
      //请求数据
      reData: [],
      //子组件 tab  index
      seleId: 0,
    };
  },
  mounted() {},
  created() {
    this.init();
  },
  methods: {
    init() {
      // 科普标本室
      cultural().then((res) => {
        // console.log(res);
        this.reData = res.data;
      });
    },
    //滚动到固定位置
    // rollPlace(index) {
    //   document.getElementById(index).scrollIntoView();
    // },
  },
  watch: {
    // 监听路由 值
    "$route.query.index"(newval) {
      // console.log("监听路由 值", newval);
      // this.rollPlace(newval);
      this.seleId = newval;
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-color {
  background-color: #fafafa;
}
</style>